import { useState } from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { InvoiceListPage as SharedInvoiceListPage } from '@/features/invoices/components/InvoiceListPage';

interface PaymentCounts {
  paid: number;
  pending: number;
}

export function InvoiceListPage() {
  const [total, setTotal] = useState<number | undefined>();
  const [paymentCounts, setPaymentCounts] = useState<PaymentCounts>({ paid: 0, pending: 0 });

  const pluralize = (count: number) => count > 1 ? 'éléments' : 'élément';

  return (
    <div>
      {/* Header */}
      <div className="tw-pt-4">
        <div className="tw-flex tw-items-center tw-gap-3">
          <FileSpreadsheet className="tw-w-8 tw-h-8 tw-text-affinicar-primary" />
          <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900 tw-mb-0">
            Factures
            {total !== undefined && (
              <span className="tw-ml-1 tw-text-base tw-font-normal tw-text-gray-400">
                ({total} {pluralize(total)})
              </span>
            )}
          </h1>
        </div>
        <div className="tw-flex tw-items-center tw-gap-3 tw-mt-4">
          <span className="tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full tw-bg-green-100 tw-text-green-700">
            {paymentCounts.paid} payée{paymentCounts.paid > 1 ? 's' : ''}
          </span>
          <span className="tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full tw-bg-orange-100 tw-text-orange-700">
            {paymentCounts.pending} en attente
          </span>
        </div>
      </div>

      <SharedInvoiceListPage
        hideTitle
        onTotalChange={setTotal}
        onPaymentCountsChange={setPaymentCounts}
      />
    </div>
  );
}
